module.exports = __webpack_public_path__ + "static/img-be3dbece1075266622221c163463d2d5.png";